import React from 'react';

const DateRange = ({
    title='Khoảng thời gian',
    labelStart = 'Ngày bắt đầu',
    labelEnd = 'Ngày kết thúc',
    startDate = '',
    endDate = '',
    onChangeStart,
    onChangeEnd,
    containerClassName = 'card card-default',
    rowClassName = 'card-body row',
    startColClassName = 'input-group col-sm-6',
    endColClassName = 'input-group col-sm-6'
}) => {
    return (
        <div className={containerClassName}>
            <div className='card-header'>
                <h3 className='card-title text-bold'>{title}</h3>
            </div>
            <div className={rowClassName}>
                <div className={startColClassName}>
                    <div style={{width: '100%'}}>
                        <div className="form-group">
                            <label>{labelStart}</label>
                            <input
                                type="date"
                                className="form-control"
                                name={'start_date'}
                                value={startDate}
                                onChange={onChangeStart}
                                maxLength="10"
                                placeholder="mm/dd/yyyy"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
                <div className={endColClassName}>
                    <div style={{width: '100%'}}>
                        <div className="form-group">
                            <label className={'w-100'}><b>{labelEnd}</b></label>
                            <input
                                type="date"
                                className="form-control"
                                name={'end_date'}
                                value={endDate}
                                onChange={onChangeEnd}
                                maxLength="10"
                                placeholder="mm/dd/yyyy"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DateRange;


